import { useGo, useTranslate } from "@refinedev/core";
import { RiSpeakAiLine } from "@remixicon/react";
import { Divider, Flex, Typography } from "antd";
import { TrackedButton } from "components/TrackedButton/";
import { useAntTheme } from "hooks/useAntTheme/";
import { AnalyticsEvents } from "types/analytics/";
import { useProjectWizardStore } from "../projects/useProjectWizardStore";
import { useSoftPaywall } from "@/providers/SoftPaywallProvider";

export const HeyGeniusButton = ({}) => {
  const t = useTranslate();
  const go = useGo();
  const { theme } = useAntTheme();
  const { setWizardStartTime } = useProjectWizardStore();
  const { paywallFlow } = useSoftPaywall();

  return (
    <Flex vertical gap={16} style={{ marginTop: 24 }}>
      <Divider plain>
        <Typography.Text type="secondary">{t("or")}</Typography.Text>
      </Divider>

      <TrackedButton
        trackingEventName={AnalyticsEvents.ProjectCreateInit}
        trackingProps={{
          project_type: "hey_genius",
          page: "project_creation_wizard",
          paywall_flow: paywallFlow,
        }}
        color="cyan"
        shape="default"
        size="large"
        variant="filled"
        onClick={() => {
          setWizardStartTime(Date.now());
          go({ to: "/media/projects/create/heygenius" });
        }}
        block
        style={{
          height: 35,
          borderRadius: theme.borderRadiusLG,
          border: `1px solid ${theme.colorPrimary}`,
          transition: "all 0.3s ease",
        }}
        icon={<RiSpeakAiLine size={20} />}
      >
        {t("projects.components.ProjectCreateWizard.createHeyGeniusProject")}
      </TrackedButton>
    </Flex>
  );
};
